import React from 'react';

const AchievementBadge = ({ 
  icon, 
  title, 
  earned = false,
  gradient = 'from-yellow-400 to-orange-500',
  className = ''
}) => {
  return (
    <div className={`inline-flex items-center px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
      earned 
        ? `bg-gradient-to-r ${gradient} text-white shadow-lg hover:shadow-xl hover:-translate-y-0.5`
        : 'bg-gray-100 text-gray-400 border border-gray-200'
    } ${className}`}>
      <span className="mr-2">{icon}</span>
      {title}
    </div>
  );
};

export default AchievementBadge;